import { render, staticRenderFns } from "./editbooking_component.vue?vue&type=template&id=c6789a96&scoped=true&"
import script from "../assets/js/editbooking.js?vue&type=script&lang=js&"
export * from "../assets/js/editbooking.js?vue&type=script&lang=js&"
import style0 from "./editbooking_component.vue?vue&type=style&index=0&id=c6789a96&scoped=true&lang=css&"
import style1 from "./editbooking_component.vue?vue&type=style&index=1&id=c6789a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6789a96",
  null
  
)

export default component.exports